import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsersIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.22039 12.8864C2.00179 12.105 3.0616 11.666 4.16667 11.666H10.8333C11.9384 11.666 12.9982 12.105 13.7796 12.8864C14.561 13.6678 15 14.7276 15 15.8327V17.4993C15 17.9596 14.6269 18.3327 14.1667 18.3327C13.7064 18.3327 13.3333 17.9596 13.3333 17.4993V15.8327C13.3333 15.1696 13.0699 14.5338 12.6011 14.0649C12.1323 13.5961 11.4964 13.3327 10.8333 13.3327H4.16667C3.50363 13.3327 2.86774 13.5961 2.3989 14.0649C1.93006 14.5338 1.66667 15.1696 1.66667 15.8327V17.4993C1.66667 17.9596 1.29357 18.3327 0.833333 18.3327C0.373096 18.3327 0 17.9596 0 17.4993V15.8327C0 14.7276 0.438987 13.6678 1.22039 12.8864Z",
			fill: "#FEFEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.5 3.33268C6.11929 3.33268 5 4.45197 5 5.83268C5 7.21339 6.11929 8.33268 7.5 8.33268C8.88071 8.33268 10 7.21339 10 5.83268C10 4.45197 8.88071 3.33268 7.5 3.33268ZM3.33334 5.83268C3.33334 3.5315 5.19882 1.66602 7.5 1.66602C9.80119 1.66602 11.6667 3.5315 11.6667 5.83268C11.6667 8.13387 9.80119 9.99935 7.5 9.99935C5.19882 9.99935 3.33334 8.13387 3.33334 5.83268Z",
			fill: "#FEFEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.8598 12.4006C15.9749 11.955 16.4294 11.687 16.875 11.8021C17.7689 12.0329 18.5608 12.554 19.1264 13.2836C19.692 14.0133 19.9993 14.9101 20 15.8333L20 17.5006C20 17.9608 19.6269 18.3339 19.1667 18.3339C18.7064 18.3339 18.3333 17.9608 18.3333 17.5006V15.8345C18.3333 15.8345 18.3333 15.8346 18.3333 15.8345C18.3329 15.2807 18.1485 14.7425 17.8092 14.3047C17.4698 13.867 16.9947 13.5543 16.4583 13.4158C16.0127 13.3007 15.7447 12.8462 15.8598 12.4006Z",
			fill: "#FEFEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.526 2.40223C12.6402 1.95637 13.0942 1.68748 13.54 1.80163C14.4363 2.03111 15.2307 2.55236 15.798 3.28321C16.3653 4.01405 16.6732 4.91291 16.6732 5.83809C16.6732 6.76327 16.3653 7.66213 15.798 8.39298C15.2307 9.12382 14.4363 9.64507 13.54 9.87455C13.0942 9.98871 12.6402 9.71981 12.526 9.27396C12.4119 8.8281 12.6808 8.37412 13.1266 8.25997C13.6644 8.12228 14.141 7.80953 14.4814 7.37102C14.8218 6.93252 15.0065 6.3932 15.0065 5.83809C15.0065 5.28299 14.8218 4.74367 14.4814 4.30516C14.141 3.86665 13.6644 3.5539 13.1266 3.41622C12.6808 3.30206 12.4119 2.84808 12.526 2.40223Z",
			fill: "#FEFEFF"
		})
	]
});
export default SvgUsersIcon;
